var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9492 17.7056H19.3778V26.277H17.9492V17.7056Z",
    fill: "#146C94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2344 17.7056H23.6629V26.277H22.2344V17.7056Z",
    fill: "#146C94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2344 13.4194V14.848H13.6629V29.1337C13.6629 29.5126 13.8135 29.876 14.0814 30.1439C14.3493 30.4118 14.7126 30.5623 15.0915 30.5623H26.5201C26.899 30.5623 27.2623 30.4118 27.5302 30.1439C27.7982 29.876 27.9487 29.5126 27.9487 29.1337V14.848H29.3772V13.4194H12.2344ZM15.0915 29.1337V14.848H26.5201V29.1337H15.0915Z",
    fill: "#146C94"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9492 10.5625H23.6635V11.9911H17.9492V10.5625Z",
    fill: "#146C94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteblue);
export default __webpack_public_path__ + "static/media/deleteblue.4b52293b57a134721a15b4d3705f076d.svg";
export { ForwardRef as ReactComponent };